import { render, staticRenderFns } from "./orderDetail2.vue?vue&type=template&id=37fafb78"
import script from "./orderDetail2.vue?vue&type=script&lang=js"
export * from "./orderDetail2.vue?vue&type=script&lang=js"
import style0 from "./orderDetail2.vue?vue&type=style&index=0&id=37fafb78&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fafb78')) {
      api.createRecord('37fafb78', component.options)
    } else {
      api.reload('37fafb78', component.options)
    }
    module.hot.accept("./orderDetail2.vue?vue&type=template&id=37fafb78", function () {
      api.rerender('37fafb78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/orderDetail2.vue"
export default component.exports